export default "__VITE_ASSET__53a6ce7f__"